// material-ui
import { Theme } from '@mui/material/styles';
import { ChipProps } from '@mui/material/Chip';

// project imports
import { withAlpha } from 'utils/colorUtils';

// ===============================||  OVERRIDES - CHIP  ||=============================== //

export default function Chip(theme: Theme) {
  return {
    MuiChip: {
      defaultProps: {
        color: 'primary' as ChipProps['color'],
        variant: 'light' as ChipProps['variant']
      },
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: 'light' }, // Variant for light Chip
              style: ({ ownerState, theme }: { ownerState: ChipProps; theme: Theme }) => {
                // Make sure color exists and is a key of palette
                const colorKey = ownerState.color as keyof typeof theme.vars.palette;
                const paletteColor = theme.vars.palette[colorKey];

                if (!paletteColor) return {};

                return {
                  color: paletteColor.main,
                  backgroundColor: paletteColor.light,

                  ...(ownerState.color === 'error' && {
                    backgroundColor: withAlpha(paletteColor.light, 0.25)
                  }),
                  ...(ownerState.color === 'success' && {
                    backgroundColor: withAlpha(paletteColor.light, 0.5)
                  }),
                  // ZERCODE CHANGE — 'info' OKUNAMIYORDU.
                  //
                  // ⚠ NEDEN: bu varyantın varsayılanı `color: main` + `backgroundColor: light`, ve
                  // Berry'nin HİÇBİR teması `info`yu tanımlamıyor — dolayısıyla MUI varsayılanı
                  // geçerli oluyor: main #0288d1, light #03a9f4. Birbirine çok yakın iki mavi:
                  // ölçülen kontrast 1.47:1 (WCAG AA normal metin için 4.5 ister), yani mavi zemin
                  // üzerinde mavi yazı. warning ve success `dark` yazıya yükseltilerek bu tuzaktan
                  // kurtarılmış; info tek başına unutulmuş.
                  //
                  // ⚠ ALFA 0.5 DEĞİL 0.35: success'in kullandığı 0.5 ile info 4.49:1'de kalıyor —
                  // eşiğin kıl payı ALTINDA. 0.35 → 5.22:1, hâlâ görünür bir mavi tonu. success'e
                  // dokunulmuyor; onun paleti temada TANIMLI ve kendi oranı zaten geçerli.
                  ...(ownerState.color === 'info' && {
                    backgroundColor: withAlpha(paletteColor.light, 0.35)
                  }),
                  ...((ownerState.color === 'warning' ||
                    ownerState.color === 'success' ||
                    ownerState.color === 'info') && {
                    color: paletteColor.dark
                  }),

                  // Dark mode styles
                  ...theme.applyStyles('dark', {
                    backgroundColor: withAlpha(paletteColor.dark, 0.15),
                    ...(ownerState.color === 'error' && {
                      backgroundColor: withAlpha(paletteColor.dark, 0.15)
                    }),
                    ...(ownerState.color === 'success' && {
                      backgroundColor: withAlpha(paletteColor.dark, 0.15)
                    }),
                    // ZERCODE CHANGE: koyu temada da 'info' aynı yükseltmeyi alır — orada zemin
                    // koyu-alfa olduğu için okunabilir olan `main`dir, `dark` değil.
                    ...((ownerState.color === 'warning' ||
                      ownerState.color === 'success' ||
                      ownerState.color === 'info') && {
                      color: paletteColor.main
                    })
                  }),

                  '&.MuiChip-clickable': {
                    '&:hover': {
                      color: paletteColor.light,
                      backgroundColor: paletteColor.dark,

                      ...theme.applyStyles('dark', {
                        color: paletteColor.dark,
                        backgroundColor: paletteColor.light
                      })
                    }
                  }
                };
              }
            },
            {
              props: { variant: 'outlined', color: 'warning' },
              style: {
                borderColor: theme.vars.palette.warning.dark,
                color: theme.vars.palette.warning.dark
              }
            },
            {
              props: { variant: 'outlined', color: 'success' },
              style: {
                borderColor: theme.vars.palette.success.dark,
                color: theme.vars.palette.success.dark
              }
            }
          ],
          '&.MuiChip-deletable .MuiChip-deleteIcon': {
            color: 'inherit'
          }
        }
      }
    }
  };
}
